import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import { LegalStatusModelImpl } from './model/legal-status-model';
import { LegalStatusModel } from './types/legal-status-model.interface';
import { LegalStatusApiDto } from './types/legal-status-api-dto.interface';
import { LegalStatusApiDtoImpl } from './repository/legal-status-api-dto';
import { LegalStatusApi } from './types/legal-status-api.interface';
import { LegalStatusApiImpl } from './repository/legal-status-api';
import { LegalStatusService } from './types/legal-status-service.interface';
import { LegalStatusServiceImpl } from './legal-status-service';
export const legalStatus = new ContainerModule(bind => {
    bind(LegalStatusModel).to(LegalStatusModelImpl);
    bind(LegalStatusApiDto).to(LegalStatusApiDtoImpl);
    bind(LegalStatusApi).to(LegalStatusApiImpl);
    bind(LegalStatusService).to(LegalStatusServiceImpl);
});
